import { useEffect, useState } from "react";
import { Loader2, Plus, Trash2 } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export default function AdminCoupons() {
  const [items, setItems] = useState(null);
  const [courses, setCourses] = useState([]);
  const [nc, setNc] = useState({ code: "", discount_type: "percentage", value: 10, expires_at: "", usage_limit: "", course_id: "", active: true });

  const load = () => api.get("/admin/coupons").then(({ data }) => setItems(data));
  useEffect(() => { load(); api.get("/admin/courses").then(({ data }) => setCourses(data)); }, []);
  if (!items) return <Loader2 className="h-8 w-8 animate-spin text-[#DCA846]" />;

  const add = async () => {
    if (!nc.code) return toast.error("Code required");
    const body = { ...nc };
    if (!body.expires_at) delete body.expires_at; else body.expires_at = new Date(body.expires_at).toISOString();
    body.usage_limit = body.usage_limit ? parseInt(body.usage_limit) : null;
    if (!body.course_id) body.course_id = null;
    await api.post("/admin/coupons", body);
    setNc({ code: "", discount_type: "percentage", value: 10, expires_at: "", usage_limit: "", course_id: "", active: true });
    load(); toast.success("Coupon created");
  };
  const patch = async (id, b) => { await api.patch(`/admin/coupons/${id}`, b); load(); };
  const del = async (id) => { await api.delete(`/admin/coupons/${id}`); load(); };

  return (
    <div className="max-w-4xl">
      <h1 className="font-display text-3xl font-bold uppercase tracking-tight">Discount Coupons</h1>

      <div className="mt-6 grid gap-3 rounded-lg border border-white/10 bg-zinc-900/40 p-5 sm:grid-cols-3">
        <Input data-testid="coupon-code" placeholder="CODE (e.g. FADE20)" value={nc.code} onChange={(e) => setNc({ ...nc, code: e.target.value.toUpperCase() })} className="bg-zinc-900 border-white/10 text-white" />
        <Select value={nc.discount_type} onValueChange={(v) => setNc({ ...nc, discount_type: v })}>
          <SelectTrigger className="bg-zinc-900 border-white/10 text-white"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-zinc-950 border-white/10 text-white"><SelectItem value="percentage">Percentage %</SelectItem><SelectItem value="fixed">Fixed $</SelectItem></SelectContent>
        </Select>
        <Input type="number" placeholder="Value" value={nc.value} onChange={(e) => setNc({ ...nc, value: parseFloat(e.target.value) || 0 })} className="bg-zinc-900 border-white/10 text-white" />
        <Input type="date" placeholder="Expires" value={nc.expires_at} onChange={(e) => setNc({ ...nc, expires_at: e.target.value })} className="bg-zinc-900 border-white/10 text-white" />
        <Input type="number" placeholder="Usage limit (optional)" value={nc.usage_limit} onChange={(e) => setNc({ ...nc, usage_limit: e.target.value })} className="bg-zinc-900 border-white/10 text-white" />
        <Select value={nc.course_id} onValueChange={(v) => setNc({ ...nc, course_id: v })}>
          <SelectTrigger className="bg-zinc-900 border-white/10 text-white"><SelectValue placeholder="All courses" /></SelectTrigger>
          <SelectContent className="bg-zinc-950 border-white/10 text-white"><SelectItem value="all">All courses</SelectItem>{courses.map((c) => <SelectItem key={c.id} value={c.id}>{c.title}</SelectItem>)}</SelectContent>
        </Select>
        <Button data-testid="add-coupon-btn" onClick={add} className="bg-[#DCA846] text-black hover:bg-[#C5963B] sm:col-span-3"><Plus className="mr-1 h-4 w-4" /> Create Coupon</Button>
      </div>

      <div className="mt-6 overflow-x-auto rounded-lg border border-white/10">
        <table className="w-full text-sm">
          <thead className="bg-zinc-900 text-left text-xs uppercase text-zinc-400"><tr><th className="p-3">Code</th><th className="p-3">Discount</th><th className="p-3">Used</th><th className="p-3">Expires</th><th className="p-3">Active</th><th className="p-3"></th></tr></thead>
          <tbody>
            {items.length === 0 ? <tr><td colSpan={6} className="p-6 text-center text-zinc-500">No coupons yet.</td></tr> :
              items.map((c) => (
                <tr key={c.id} className="border-t border-white/5">
                  <td className="p-3 font-mono">{c.code}</td>
                  <td className="p-3">{c.discount_type === "percentage" ? `${c.value}%` : `$${c.value}`}</td>
                  <td className="p-3">{c.used_count}{c.usage_limit ? `/${c.usage_limit}` : ""}</td>
                  <td className="p-3 text-zinc-500">{c.expires_at ? new Date(c.expires_at).toLocaleDateString() : "-"}</td>
                  <td className="p-3"><Switch checked={!!c.active} onCheckedChange={(v) => patch(c.id, { active: v })} /></td>
                  <td className="p-3"><button onClick={() => del(c.id)} className="text-red-400"><Trash2 className="h-4 w-4" /></button></td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
